import { StringEqualsFilterC } from "app/search/codecs/StringEqualsFilterC"
import { StringEqualsMultipleFilterC } from "app/search/codecs/StringEqualsMultipleFilterC"
import * as t from "io-ts"

export const BrandSearchFilterC = t.union([StringEqualsMultipleFilterC, StringEqualsFilterC])

export type BrandSearchFilter = t.TypeOf<typeof BrandSearchFilterC>
